import React, { useEffect } from 'react';
import './DefaultQuestionnaireModal.css';

export interface DefaultQuestionnaireModalProps {
  isOpen: boolean;
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'default' | 'lg';
  position?: 'center' | 'top';
  setup?: boolean;
  onClose: () => void;
}

const DefaultQuestionnaireModal: React.FC<DefaultQuestionnaireModalProps> = ({
  isOpen,
  title = '',
  children,
  footer,
  size = 'default',
  position = 'center',
  setup = false,
  onClose,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={`dq-modal-backdrop ${position === 'top' ? 'dq-modal-backdrop--top' : ''}`} onClick={onClose}>
      <div
        className={`dq-modal-dialog ${size === 'lg' ? 'dq-modal-dialog--lg' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        {title ? (
          <div className="dq-modal-header">
            <h5 className="dq-modal-title">{title}</h5>
            <button type="button" className="dq-modal-close" onClick={onClose}>
              <i className="fal fa-xmark"></i>
            </button>
          </div>
        ) : (
          setup ? (
            <button type="button" className="dq-modal-close" onClick={onClose} style={{ position: 'absolute', top: '1.5rem', right: '1.5rem' }}>
              <i className="fal fa-xmark"></i>
            </button>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0.75rem 1rem 0' }}>
              <button type="button" className="dq-modal-close" onClick={onClose}>
                <i className="fal fa-xmark"></i>
              </button>
            </div>
          )
        )}

        {/* Body */}
        <div className="dq-modal-body">{children}</div>

        {/* Footer */}
        {footer && <>{footer}</>}
      </div>
    </div>
  );
};

export default DefaultQuestionnaireModal;
